import LoadingHigharcIcon from "./LoadingHigharcIcon";

## Basic Usage

<LoadingHigharcIcon />

The rotating arc telegraphs progress without a percent value — use it for indeterminate
"working / thinking / loading" states.

---

## Sizes

<div style={{ display: "flex", gap: "1rem", alignItems: "center" }}>
  <LoadingHigharcIcon size={16} />
  <LoadingHigharcIcon size={20} />
  <LoadingHigharcIcon size={32} />
  <LoadingHigharcIcon size={48} />
</div>

---

## Themed via CSS custom properties

<div style={{ display: "flex", gap: "1rem", alignItems: "center" }}>
  <div style={{ ["--loading-higharc-icon-bg"]: "#4ed694", ["--loading-higharc-icon-arc"]: "#ffffff" }}>
    <LoadingHigharcIcon size={32} />
  </div>
  <div style={{ ["--loading-higharc-icon-bg"]: "#336cb8", ["--loading-higharc-icon-arc"]: "#d8e3f2" }}>
    <LoadingHigharcIcon size={32} />
  </div>
  <div style={{ ["--loading-higharc-icon-bg"]: "#111827", ["--loading-higharc-icon-arc"]: "#f9fafb" }}>
    <LoadingHigharcIcon size={32} />
  </div>
</div>

---

## Inline with text

<div style={{ display: "inline-flex", gap: "0.5rem", alignItems: "center", color: "#616161" }}>
  <LoadingHigharcIcon size={16} />
  <span>Thinking…</span>
</div>
